import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Query from './Query';
import Library from './Library';
import Upload from './Upload';
import Detail from './Detail';

const DocsContainer: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Query />} />
      <Route path="/library" element={<Library />} />
      <Route path="/upload" element={<Upload />} />
      <Route path="/:id" element={<Detail />} />
    </Routes>
  );
};

export default DocsContainer;
